// src/components/ui/2-organisms/RecommendedRings/RecommendedRings.js

import React from 'react';
import SectionHeader from '../../1-molecules/SectionHeader/SectionHeader';
import StorefrontRingGrid from '../StorefrontRingGrid/StorefrontRingGrid';
import styles from './RecommendedRings.module.css';

/**
 * Displays up to 2 recommended rings based on user's style profile.
 * This component replaces the banner rings that were previously shown in StorefrontProfileHeader.
 * 
 * @param {object} props
 * @param {Array<object>} props.topRings - Array of ring objects matched to user's style
 * @param {function(object): void} props.onRingClick - Callback when a ring is clicked
 */
const RecommendedRings = ({ topRings, onRingClick }) => {
  // Don't render if no rings available
  if (!topRings || topRings.length === 0) {
    return null;
  }

  // Only take the first 2 rings (same as the banner was showing)
  const ringsToDisplay = topRings.slice(0, 2);

  return (
    <div className={styles.section}>
      <SectionHeader 
        title="We think you'll like..." 
      />
      <StorefrontRingGrid 
        rings={ringsToDisplay}
        onRingClick={onRingClick}
      />
    </div>
  );
};

export default React.memo(RecommendedRings);